<style>
form {
    padding: 0;
    margin: 0;
    width: 0;
    height: 0;
    overflow: hidden;
    visibility: hidden;
}
</style>
<script lang="ts" context="module">
export type EmailTemplate = [label: string, template: string];
import { tick } from 'svelte';
import api, { Command } from '../api';
import type { Lecture } from '../api/types';
interface FormPayload {
    template: string;
    course: string;
    lecture?: string;
}
</script>
<script lang="ts">
export let items: EmailTemplate[];
export let courseId: string;
export let lectureId: string | undefined = undefined;
let form: HTMLFormElement;
let formData: FormPayload | undefined;

async function preview(template: string) {
    let lecture: Lecture;
    const { course } = await api.get(Command.Course, { id: courseId });

    if (lectureId) {
        const resp = await api.get(Command.Lecture, { id: lectureId });
        lecture = resp.lecture;
    }

    formData = {
        template,
        course: JSON.stringify(course)
    };

    if (lecture) {
        formData.lecture = JSON.stringify(lecture);
    }

    await tick();
    form.submit();
    formData = null;
}

</script>
<h2>Предпросмотр писем</h2>
<ul>
    {#each items as item}
        <li><a on:click|preventDefault={() => preview(item[1])} href="/email/?template={item[1]}">{item[0]}</a></li>
    {/each}
</ul>
{#if formData}
    <form method="POST" action="/email/?template={formData.template}" target="_blank" bind:this={form}>
        <input type="hidden" name="course" value={formData.course} />
        {#if formData.lecture}
            <input type="hidden" name="lecture" value={formData.lecture} />
        {/if}
        <input type="submit" value="Submit" />
    </form>
{/if}
